import axios from 'axios';

const state = {
    attendances: [],
    coreGroupMembers: [],
    eventId: {}
};

const getters = {
    coreGroupMembers: state => state.coreGroupMembers,
    attendances: state => state.attendances
};

const actions = {
    fetchCoreGroupMembers({ commit, rootState, dispatch }, payload) {
        return new Promise((resolve, reject) => {
            axios.post(`/api/proxy/coregroupsMembers/${rootState.coreGroupId}`)
                .then(response => {
                    console.log('coreGroupMembersResponse', response.data.coreGroup);
                    if (response.data.coreGroup) {
                        commit('setCoreGroupMembers', response.data.coreGroup.coreGroupMembers);
                        dispatch('fetchAttendances', payload);
                    }
                })
                .catch(e => {
                    reject(e);
                });
        });
    },
    fetchAttendances: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            axios.post('/api/attendances/fetch', {
                classCalendarScheduleReferenceID: payload.classCalendarScheduleReferenceID,
                classSessionID: payload.classSessionID
            })
                .then(response => {
                    console.log('attendances response', response.data)
                    commit('setAttendances', { attendances: response.data.getListofAttendancebyClassSessionId })
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    updateAttendances: ({ state, dispatch }, payload) => {
        return new Promise((resolve, reject) => {
            axios.post(`/api/attendances/update`, {
                items: state.attendances,
                classCalendarScheduleReferenceID: payload.classCalendarScheduleReferenceID,
                classSessionID: payload.classSessionID
            })
                .then(response => {
                    console.log('Update attendances', response);
                    dispatch('fetchCoreGroupMembers', payload);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    autoAttendance: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.post(`/api/attendances/auto`, {
                personId: payload.personId,
                meetingId: payload.meetingId
            })
                .then(response => {
                    console.log('Auto attendance', response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }
};

const mutations = {
    setCoreGroupMembers: (state, coreGroupMembers) => (state.coreGroupMembers = coreGroupMembers),
    setAttendances(state, payload) {
        state.attendances = []
        state.coreGroupMembers.forEach(m => {
            let attended = false;
            payload.attendances.forEach(a => {
                if (m.personID === a.personId) {
                    attended = a.isAttendance;
                }
            });
            state.attendances.push({ firstName: m.firstName, lastName: m.lastName, personID: m.personID, attended: attended });
        });
    },
    setEventId: (state, eventId) => (state.eventId = eventId)
};

export default {
    state,
    getters,
    actions,
    mutations
};